import { defineMessages } from 'react-intl'

const messages = defineMessages({
  absoluteValuesEvolution: {
    id: 'ContentChartTitle',
    description: 'Texto para el titulo del gráfico de lineas en la capa 3',
    defaultMessage: 'Evolución'
  },
  map: {
    id: 'ContentChartTitle.map',
    description: 'Texto para el titulo del gráfico de mapa en la capa 3',
    defaultMessage: 'Mapa'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/ContentChartTitle/messages.js